
    import queryString      from 'query-string';
    import * as Components  from 'js/proj/components';
    import JSCookie         from 'js-cookie';

    export const CookieName = PROJECT_ID.split("-").join("_");
    export const CookieParams = { expires: 7 };

    export const Visited = () => JSCookie.get(CookieName) != undefined ? JSCookie.get(CookieName).split(":") : undefined;
    export const SetCookie = (p_val) => Visited() == undefined ? JSCookie.set(CookieName, p_val, CookieParams) : (Visited().indexOf(("" + p_val)) == -1) ? JSCookie.set(CookieName, (Visited().join(":") + (":" + p_val)), CookieParams) : null;
    export const ClearCookie = () => JSCookie.remove(CookieName);
    export const Query = () => location.search ? queryString.parse(location.search) : {};

    export const GridSize = { XS : "xs", SM : "sm", MD : "md", LG : "lg", XL : "xl" };
    export const Mode = { DESKTOP : "desktop", TABLET : "tablet", MOBILE : "mobile" };

    export const Breakpoint = () => window.getComputedStyle ? window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').split("\"").join("") : null;

    export const isObject = value => value && typeof value === 'object' && value.constructor === Object;

    export const GetComponent = (val, id, props) =>
    {
        if(Components && val && val.type)
        {
            let ComponentTag = Components[(val.type.charAt(0).toUpperCase() + val.type.substring(1))];

            return ComponentTag
                ? <ComponentTag key={ ("component-" + id) } { ...val } { ...props } />
                : null;
        }
    }

    export const GetElementPosition = ( el, axis="top" ) =>
    {
        let pos = 0;

        el = el || this.element;
        axis = (axis.substr(0, 1).toUpperCase() + axis.substr(1, axis.length));

        do {
            pos += !isNaN( el['offset' + axis]) ? el['offset' + axis] : 0;
        } while( el = el.offsetParent );

        return pos;
    }

    export const StopAllMediaPlayers = referringElement =>
    {
        let audio = [].slice.call(document.querySelectorAll('audio')),
            video = [].slice.call(document.querySelectorAll('video')),
            list = referringElement ? [...audio, ...video].filter(val => val != referringElement) : [...audio, ...video];
            
        list.forEach(val => val.pause());
    }